import _ from 'lodash'

export default function guestOrVerified ({ next, store }) {
  const profile = store.getters['auth/profile']
  if (_.isNil(profile)) {
    if (profile.codeUserType.includes(['USRA', 'USRS', 'GUEST']) || _.isNil(_.isEqual(profile.status, 'ANDALINVERIFICATION'))) {
      return next({
        name: 'Signin'
      })
    }
  }
  return next()
}



// WEBPACK FOOTER //
// ./src/middleware/guestOrVerified.js